import script from "./BuzzSideNavDash.vue?vue&type=script&setup=true&lang=js"
export * from "./BuzzSideNavDash.vue?vue&type=script&setup=true&lang=js"

import "./BuzzSideNavDash.vue?vue&type=style&index=0&id=b93ff3f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b93ff3f2"]])

export default __exports__